export interface ComicCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export interface ComicArticle {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  author: string;
  status: 'serializing' | 'completed';
  rating: number;
  views: number;
  favorites: number;
  tags: string[];
  updateDate: string;
  chapters: number;
  content?: string;
  chapters_list?: ComicChapter[];
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
  pages: number;
}

export interface FAQItem {
  question: string;
  answer: string;
}

export const categories: ComicCategory[] = [
  {
    id: 'cat-1',
    name: '恋爱言情',
    slug: 'romance',
    description: '甜蜜浪漫的爱情故事，心动时刻尽在笔下',
    icon: 'ri-heart-line',
    count: 128,
  },
  {
    id: 'cat-2',
    name: '都市生活',
    slug: 'urban',
    description: '现代都市中的情感纠葛与人生百态',
    icon: 'ri-building-line',
    count: 96,
  },
  {
    id: 'cat-3',
    name: '奇幻冒险',
    slug: 'fantasy',
    description: '异世界冒险，奇幻旅程精彩纷呈',
    icon: 'ri-magic-line',
    count: 84,
  },
  {
    id: 'cat-4',
    name: '古风仙侠',
    slug: 'xianxia',
    description: '唯美古风，仙侠世界的情缘故事',
    icon: 'ri-cloud-line',
    count: 72,
  },
  {
    id: 'cat-5',
    name: '悬疑推理',
    slug: 'mystery',
    description: '扣人心弦的悬疑故事，层层揭秘',
    icon: 'ri-search-eye-line',
    count: 56,
  },
  {
    id: 'cat-6',
    name: '校园青春',
    slug: 'school',
    description: '青涩校园时光，纯真爱恋回忆',
    icon: 'ri-book-open-line',
    count: 108,
  },
  {
    id: 'cat-7',
    name: '职场商战',
    slug: 'workplace',
    description: '职场风云，商场博弈中的爱恨情仇',
    icon: 'ri-briefcase-line',
    count: 48,
  },
  {
    id: 'cat-8',
    name: '百合纯爱',
    slug: 'yuri',
    description: '纯真美好的情感，细腻动人的故事',
    icon: 'ri-flower-line',
    count: 64,
  },
];

export const articles: ComicArticle[] = [
  {
    id: 'article-1',
    title: '总裁的秘密情人',
    slug: 'ceo-secret-lover',
    category: '都市生活',
    categorySlug: 'urban',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20romance%20manhwa%20style%20cover%20art%2C%20handsome%20CEO%20in%20dark%20suit%20with%20mysterious%20expression%2C%20soft%20warm%20lighting%2C%20rose%20petals%20falling%2C%20dramatic%20composition%2C%20Korean%20webtoon%20aesthetic%2C%20clean%20illustration%20style%2C%20simple%20gradient%20background%2C%20romantic%20atmosphere&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    description: '她只是一个小小的秘书，却意外成为了冷酷总裁的秘密情人。一段不可告人的关系，两颗逐渐靠近的心。当真相浮出水面，他们的感情又将何去何从？',
    author: '墨染青衣',
    status: 'serializing',
    rating: 4.8,
    views: 1258000,
    favorites: 89600,
    tags: ['都市', '总裁', '甜宠', '契约爱情'],
    updateDate: '2026-08-09',
    chapters: 156,
    content: '<p>林小雨从未想过，自己平凡的人生会因为一份秘书工作彻底改变。</p><p>那天，她像往常一样整理文件，却不小心撞进了总裁办公室的秘密。冷厉深沉的顾言琛，在那一瞬间卸下了所有伪装。从那天起，一纸秘密契约将两个人紧紧绑在一起。</p><p>"做我的情人，我给你想要的一切。"</p><p>她以为这只是一场交易，却不知自己早已落入了他的深情陷阱。当秘密被揭开，当信任被动摇，他们会选择相信彼此，还是就此形同陌路？</p><p>一段始于契约的恋情，能否开出真心的花？</p>',
  },
  {
    id: 'article-2',
    title: '异世界恋爱攻略',
    slug: 'isekai-love-guide',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20manga%20style%20cover%2C%20beautiful%20female%20knight%20with%20silver%20armor%20and%20flowing%20hair%2C%20magical%20glowing%20elements%2C%20dragon%20silhouette%20in%20background%2C%20ethereal%20atmosphere%2C%20Japanese%20light%20novel%20illustration%20style%2C%20soft%20pastel%20colors%2C%20dreamy%20fantasy%20world&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    description: '普通上班族意外穿越到剑与魔法的世界，却发现这里的恋爱法则完全不同！魔法、冒险、还有命中注定的邂逅，异世界的浪漫冒险正式开启。',
    author: '星野琉璃',
    status: 'serializing',
    rating: 4.6,
    views: 982000,
    favorites: 72300,
    tags: ['异世界', '冒险', '魔法', '后宫'],
    updateDate: '2026-08-08',
    chapters: 98,
  },
  {
    id: 'article-3',
    title: '仙尊的白月光',
    slug: 'immortal-white-moonlight',
    category: '古风仙侠',
    categorySlug: 'xianxia',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20romance%20manhua%20cover%2C%20ethereal%20female%20cultivator%20in%20flowing%20white%20hanfu%2C%20cherry%20blossom%20petals%2C%20misty%20mountain%20background%2C%20celestial%20palace%20in%20distance%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20elegant%20and%20dreamy%20atmosphere&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    description: '她是他修行千年唯一的心魔，也是他甘愿堕入凡尘的理由。仙尊与凡女，天上人间，一段跨越三界的禁忌之恋。',
    author: '云中君',
    status: 'completed',
    rating: 4.9,
    views: 2150000,
    favorites: 156000,
    tags: ['仙侠', '古风', '虐恋', '轮回'],
    updateDate: '2026-07-25',
    chapters: 200,
  },
  {
    id: 'article-4',
    title: '学生会长的秘密',
    slug: 'student-president-secret',
    category: '校园青春',
    categorySlug: 'school',
    coverImage: 'https://readdy.ai/api/search-image?query=School%20romance%20anime%20style%20cover%2C%20handsome%20student%20council%20president%20in%20school%20uniform%2C%20cherry%20blossom%20tree%2C%20sunset%20golden%20hour%20lighting%2C%20soft%20and%20warm%20atmosphere%2C%20Japanese%20high%20school%20setting%2C%20youthful%20romantic%20vibe%2C%20clean%20illustration&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    description: '完美无缺的学生会长，私下却有着不为人知的另一面。当这个秘密被新来的转学生撞破，两人的命运就此纠缠在一起。',
    author: '浅梦如烟',
    status: 'serializing',
    rating: 4.7,
    views: 1560000,
    favorites: 102000,
    tags: ['校园', '学生会', '甜宠', '青春'],
    updateDate: '2026-08-09',
    chapters: 89,
  },
  {
    id: 'article-5',
    title: '暗夜追踪者',
    slug: 'night-tracker',
    category: '悬疑推理',
    categorySlug: 'mystery',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20cover%2C%20detective%20couple%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20moonlight%20and%20streetlamp%20lighting%2C%20suspenseful%20mood%2C%20mature%20art%20style%2C%20red%20and%20black%20color%20scheme%2C%20film%20noir%20inspired%2C%20mysterious%20silhouettes&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    description: '连环案件频发，警队精英与神秘私家侦探联手出击。在追逐真相的路上，危险与诱惑并存。每一个线索背后，都隐藏着更深的秘密。',
    author: '夜未央',
    status: 'serializing',
    rating: 4.5,
    views: 876000,
    favorites: 54800,
    tags: ['悬疑', '推理', '都市', '强强'],
    updateDate: '2026-08-07',
    chapters: 67,
  },
  {
    id: 'article-6',
    title: '玫瑰与荆棘',
    slug: 'rose-and-thorns',
    category: '恋爱言情',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20manga%20cover%2C%20elegant%20woman%20in%20red%20dress%20holding%20rose%2C%20thorny%20vines%20wrapping%20around%2C%20dramatic%20lighting%2C%20passionate%20yet%20bittersweet%20atmosphere%2C%20mature%20romance%20theme%2C%20deep%20red%20and%20dark%20tones%2C%20artistic%20composition&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    description: '她是带刺的玫瑰，他是温柔的园丁。一段充满误解与偏见的相遇，一场关于爱与救赎的旅程。当荆棘被玫瑰的芬芳融化，真爱能否战胜一切？',
    author: '花间一壶酒',
    status: 'completed',
    rating: 4.8,
    views: 1890000,
    favorites: 134000,
    tags: ['言情', '虐恋', '治愈', '现代'],
    updateDate: '2026-06-30',
    chapters: 180,
  },
  {
    id: 'article-7',
    title: '办公室恋情守则',
    slug: 'office-romance-rules',
    category: '职场商战',
    categorySlug: 'workplace',
    coverImage: 'https://readdy.ai/api/search-image?query=Office%20romance%20webtoon%20cover%2C%20professional%20woman%20and%20man%20in%20modern%20office%2C%20glass%20windows%20and%20city%20skyline%2C%20warm%20indoor%20lighting%2C%20professional%20yet%20romantic%20vibe%2C%20clean%20modern%20Korean%20webtoon%20style%2C%20subtle%20chemistry%20between%20characters&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    description: '在竞争激烈的广告公司，两个竞争对手被迫合作一个大项目。办公室的斗争与暗涌的情愫，谁才是最后的赢家？',
    author: '写字楼故事',
    status: 'serializing',
    rating: 4.4,
    views: 645000,
    favorites: 41200,
    tags: ['职场', '办公室恋情', '商战', '欢喜冤家'],
    updateDate: '2026-08-06',
    chapters: 55,
  },
  {
    id: 'article-8',
    title: '花与蝶',
    slug: 'flower-and-butterfly',
    category: '百合纯爱',
    categorySlug: 'yuri',
    coverImage: 'https://readdy.ai/api/search-image?query=Yuri%20romance%20manga%20cover%2C%20two%20beautiful%20women%20gently%20holding%20hands%2C%20flower%20garden%20background%2C%20soft%20pastel%20color%20palette%2C%20butterflies%20floating%20around%2C%20gentle%20and%20pure%20atmosphere%2C%20watercolor%20art%20style%2C%20delicate%20and%20feminine%20aesthetic&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    description: '她是安静内向的花店老板，她是活泼开朗的芭蕾舞者。两个截然不同的灵魂，在花与蝶的交织中慢慢靠近彼此。一段纯净美好的感情，悄然绽放。',
    author: '蝶恋花',
    status: 'serializing',
    rating: 4.7,
    views: 782000,
    favorites: 65800,
    tags: ['百合', '纯爱', '治愈', '日常'],
    updateDate: '2026-08-08',
    chapters: 72,
  },
];

export const featuredComics: ComicArticle[] = [
  articles[2],
  articles[0],
  articles[5],
  articles[3],
];

export const latestUpdates: ComicArticle[] = [
  articles[0],
  articles[3],
  articles[7],
  articles[4],
  articles[6],
  articles[1],
];

export const faqItems: FAQItem[] = [
  {
    question: '羞羞漫画是否完全免费？',
    answer: '羞羞漫画提供大量免费漫画资源供用户畅读。同时，我们也提供VIP会员服务，VIP会员可享受无广告、高清画质、提前解锁等专属权益。新用户注册即送3天VIP体验。',
  },
  {
    question: '如何注册羞羞漫画账号？',
    answer: '您可以通过手机号或邮箱快速注册羞羞漫画账号。点击网站右上角的"注册"按钮，按照提示填写相关信息即可完成注册。注册成功后即可享受全部免费内容。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '羞羞漫画平台上的作品每日均有更新。热门连载作品通常保持每周3-5话的更新频率。您可以在"最新更新"板块查看每日更新的漫画列表。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！羞羞漫画支持手机、平板、电脑等多种设备。我们的网站采用响应式设计，在手机上同样提供流畅的阅读体验。您还可以将网站添加到手机主屏幕，像使用App一样便捷。',
  },
  {
    question: '如何查找我想看的漫画？',
    answer: '您可以通过多种方式找到喜欢的漫画：使用顶部的搜索框输入漫画名称；通过分类页面按类型浏览；查看首页的热门推荐和最新更新板块。我们还提供了标签筛选功能，帮助您精准定位感兴趣的内容。',
  },
  {
    question: '阅读记录和收藏会保存吗？',
    answer: '注册并登录账号后，您的阅读记录、收藏列表、订阅内容等数据都会自动保存。即使更换设备，登录同一账号即可同步所有数据，随时随地继续阅读。',
  },
  {
    question: '漫画的画质怎么样？',
    answer: '羞羞漫画坚持提供高清无水印的阅读体验。所有漫画均采用高分辨率图片，确保每一格的细节都清晰可见。VIP会员还可享受更高画质的阅读模式。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '您可以通过"关于我们"页面的联系表单向我们反馈问题，或发送邮件至客服邮箱。我们的客服团队会在24小时内回复您的咨询。',
  },
];

export const articleChapters: Record<string, ComicChapter[]> = {
  'article-1': Array.from({ length: 50 }, (_, i) => ({
    id: `ch-1-${i + 1}`,
    title: `第${i + 1}话${i === 0 ? ' 命运的相遇' : i === 49 ? ' 最终章' : ''}`,
    number: i + 1,
    updateDate: `2026-${String(8 - Math.floor(i / 10)).padStart(2, '0')}-${String(Math.max(1, 31 - i)).padStart(2, '0')}`,
    pages: Math.floor(Math.random() * 30) + 15,
  })),
  'article-3': Array.from({ length: 30 }, (_, i) => ({
    id: `ch-3-${i + 1}`,
    title: `第${i + 1}话${i === 0 ? ' 三界初遇' : i === 29 ? ' 轮回之约（完）' : ''}`,
    number: i + 1,
    updateDate: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(Math.max(1, 31 - i)).padStart(2, '0')}`,
    pages: Math.floor(Math.random() * 25) + 18,
  })),
};

export const aboutInfo = {
  brandName: '羞羞漫画',
  subtitle: '正版成人漫画阅读平台',
  introduction: '羞羞漫画成立于2020年，是国内领先的成人漫画在线阅读平台。我们致力于为用户提供优质、正版的漫画阅读体验，汇聚了海内外众多优秀漫画创作者的作品。平台拥有超过5000部正版授权漫画，每日更新量超过100话，累计注册用户突破500万人。',
  mission: '让每一位漫画爱好者都能随时随地享受高品质的阅读体验，打造国内最值得信赖的成人漫画平台。',
  stats: [
    { label: '正版漫画', value: '5000+', icon: 'ri-book-read-line' },
    { label: '注册用户', value: '500万+', icon: 'ri-user-heart-line' },
    { label: '签约作者', value: '800+', icon: 'ri-pen-nib-line' },
    { label: '日更新量', value: '100+', icon: 'ri-refresh-line' },
  ],
  features: [
    { title: '正版授权', description: '所有漫画均获得正版授权，支持创作者，享受高品质阅读', icon: 'ri-shield-check-line' },
    { title: '每日更新', description: '海量漫画每日更新，热门连载作品保持高频更新节奏', icon: 'ri-calendar-check-line' },
    { title: '高清画质', description: '全站漫画高清无水印，每一格细节都清晰呈现', icon: 'ri-hd-line' },
    { title: '多端适配', description: '支持手机、平板、电脑多端阅读，随时随地轻松追更', icon: 'ri-device-line' },
  ],
  testimonials: [
    { name: '漫画爱好者王先生', content: '羞羞漫画的画质真的很棒，更新速度也很快，每天都会来看看有没有新章节。已经成为我生活中不可或缺的一部分了！', rating: 5 },
    { name: '资深读者李女士', content: '用了很多漫画平台，羞羞漫画的体验是最好的。分类清晰，找漫画很方便，而且VIP价格也很合理。推荐给所有喜欢看漫画的朋友！', rating: 5 },
    { name: '新用户张同学', content: '朋友推荐来的，注册就送了3天VIP。漫画种类很丰富，画风也很精美。现在已经充了年费会员，太值了！', rating: 5 },
  ],
  contact: {
    email: 'service@xiuxiumanhua.com',
    wechat: 'xiuxiumanhua',
    weibo: '@羞羞漫画官方微博',
    workingHours: '周一至周日 9:00 - 21:00',
    address: '中国上海市浦东新区张江高科技园区',
  },
};